"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HeadingSize = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

// Heading
// =======
var HeadingSize;
exports.HeadingSize = HeadingSize;

(function (HeadingSize) {
  HeadingSize["megasmalldivider"] = "megasmalldivider";
  HeadingSize["extrasmall"] = "extrasmall";
  HeadingSize["small"] = "small";
  HeadingSize["medium"] = "medium";
  HeadingSize["large"] = "large";
  HeadingSize["extralarge"] = "extralarge";
})(HeadingSize || (exports.HeadingSize = HeadingSize = {}));

var Heading = function Heading(_ref) {
  var _HeadingSize$megasmal;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? HeadingSize.large : _ref$type,
      children = _ref.children,
      className = _ref.className,
      inlineStyles = _ref.inlineStyles,
      _ref$underline = _ref.underline,
      underline = _ref$underline === void 0 ? false : _ref$underline,
      id = _ref.id,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["type", "children", "className", "inlineStyles", "underline", "id"]);
  var _component = (_HeadingSize$megasmal = {}, (0, _defineProperty2["default"])(_HeadingSize$megasmal, HeadingSize.megasmalldivider, 'h5'), (0, _defineProperty2["default"])(_HeadingSize$megasmal, HeadingSize.extrasmall, 'h4'), (0, _defineProperty2["default"])(_HeadingSize$megasmal, HeadingSize.small, 'h3'), (0, _defineProperty2["default"])(_HeadingSize$megasmal, HeadingSize.medium, 'h2'), (0, _defineProperty2["default"])(_HeadingSize$megasmal, HeadingSize.large, 'h1'), (0, _defineProperty2["default"])(_HeadingSize$megasmal, HeadingSize.extralarge, 'h1'), _HeadingSize$megasmal)[type];
  return _react["default"].createElement(_component, (0, _extends2["default"])({
    className: (0, _classnames["default"])(_index["default"][type], className),
    style: inlineStyles,
    id: id
  }, props), _react["default"].createElement("span", {
    className: underline ? _index["default"].underline : undefined
  }, children));
};

var _default = Heading;
exports["default"] = _default;